import type { Customer } from '@/components/layout/main-header/connected/CustomerSelectorDropdown.interfaces'
import { sortName } from '@/helpers/Sorting.helpers'

export const sortWithNegativeIdFirst = (a: Customer, b: Customer) => {
  if (a.id <= 0) {
    return -1
  }
  if (b.id <= 0) {
    return 1
  }
  return sortName(a, b)
}
